//cart related
var cartItemId, variantId, existingVariant = '';
var customizedImages, customPersonlizeLinks = [];
var cartCustomInputEle, cartSubmit, cartItemRefresh;

//reorder related
var reorderLineItemCount = 0;
var reorderTotalItems = 0;
Shopify.queue = [];
var customReorderProductToCart = {};

//common
document.addEventListener("DOMContentLoaded", function () {
    // Custom input validation on input change
    cartCustomInputEle = $('.Anzahl_Etiketten_cart_custom_count');
    cartSubmit = $('.cart-submit');

    // getLoadPrintLaneImages();

});

var editDesignEle = '';
var labelDesignProps = {};

var printlaneEditCallback = function (id, token, image) {

    // Close the app
    printlane.close();

    openHoneyLoader()

    // Check if the token is valid
    if (token.length === 0) return;

    // Create a reference and key for local storage
    const reference = `${id}.${token}`;

    getLabelDesignOnReorder(labelDesignProps, 'cart-label-edit');

}

  function editPrintlaneLabel(id) {
    // return true;
    var colorlabKey = id.split('.')
    printlane.open({
      shop: '63f7aa08fb1272890590633f',
    //   product: template_id,
      id: colorlabKey[0].trim(),
      token: colorlabKey[1].trim(),
      language: document.documentElement.lang,
      callback: printlaneEditCallback,
      options: {
        generateThumbnail: true,
        generateThumbnailType: 'base64',
      }
    });

  }

// Function to process reorder design
function processEditDesign(ele, designId) {
    editDesignEle = $(ele);
    selectedPropsGlobal = editDesignEle.attr('data-product-properties').trim();
    const parsedObject = JSON.parse(selectedPropsGlobal);

    // return true;
    var editedItemProps = {
        "SKU": '',
        [customProperties.labelWidth]: '',
        [customProperties.labelHeight]: '',
        [customProperties.numberOflabels]: '',
        [customProperties.labelType]: '',
        [customProperties.material]: '',
        [customProperties.adhesive]: '',
        [customProperties.windingDirection]: '',
        [customProperties.windingLeftRight]: '',
        "customization reference": ''
    };

    $.each(parsedObject, function (key, itemProp) {

        var itemKey = decode(itemProp[0]);
        var itemValue = decode(itemProp[1]);

        if (editedItemProps.hasOwnProperty(itemKey)) {
            editedItemProps[itemKey] = itemValue
        }
    })
    removeEmptyKeys(editedItemProps);

    labelDesignProps = {
        productId: Number(editDesignEle.attr('data-product-id').trim()),
        productName: editDesignEle.attr('data-product-name').trim(),
        productSKU: editedItemProps['SKU'],
        store: storeGlobal,
        variantId: Number(editDesignEle.attr('data-variant-id').trim()),
        customerId: Number(editDesignEle.attr('data-customer-id').trim()),
        selectedProperties: editedItemProps || '',
        customerEmail: editDesignEle.attr('data-customer-email').trim(),
        customerName: editDesignEle.attr('data-customer-name').trim(),
        labelWidth: Number(editDesignEle.attr('data-product-width').trim()),
        labelHeight: Number(editDesignEle.attr('data-product-height').trim()),
        designBase64Format: '',
        token: editedItemProps['customization reference'],
        event: 'AddToCart',
        nickName: 'item-cart-design',
    };

    editPrintlaneLabel(designId, labelDesignProps);

}


// async function getCartImagePrintlaneThumb(token, itemImage){
//     var designBase64Format = await printlane.loadThumbnail(token,'base64');
//     itemImage.attr('src', designBase64Format);
// }

// function checkImageExists(url) {
//     return new Promise((resolve) => {
//         const img = new Image();
//         img.onload = () => resolve(true);  // Image loaded successfully
//         img.onerror = () => resolve(false); // Error occurred (file doesn't exist)
//         img.src = url; // Set the source to trigger loading
//     });
// }

// function getLoadPrintLaneImages() {
//     $('.cart-item-image').each(function(i, ele) {
//         var itemImage = $(ele);
//         var printLaneReferenceKey = $(ele).attr('data-printlanereference') || '';
//         var imagepath = '';
//         imagepath = "https://new-production.honeystickers.com/storage/custom-designs/us/"+printLaneReferenceKey+'.png';
//         checkImageExists(imagepath).then(exists => {
//             if (exists) {
//                 itemImage.attr('src', imagepath);
//             } else {
//                 getCartImagePrintlaneThumb(printLaneReferenceKey, itemImage);
//             }
//         });
//     });
// }

/**decode html encoded string */
function decode(str) {
    let txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

function processChange(cartCustomInputEleId, count = 0) {

    const input = document.getElementById(cartCustomInputEleId);
    var productType = input?.getAttribute("data-product-type")?.trim();

    let currentValue = parseInt(input.value) || 0;
    let newValue = currentValue + count;
    input.value = newValue;
    if (productType == 'Mustermappe') {
        return true
    } else {
        validateCustomInput('#' + cartCustomInputEleId);
    }

}

// Helper: check if product has any tag that hides winding
function hasHideWindingForCartItem(productTags) {
    const hideWindingTags = [
        "Etichetta con sigillo di garanzia",
        "Etikett mit Gewährverschluss",
        "étiquette de scellage",
        "Tamper Seal Label",
        "Label with Tamper Seal",
        "Seal Sticker"
    ];

    return hideWindingTags.some(tag => productTags.includes(tag));
}

function checkRollCount(ele) {
    if (!ele) return;

    const labelType = ele.value;
    const variantId = (ele.getAttribute('data-variantId') || '').trim();
    if (!variantId) return;

    const countInput = document.getElementById(`Anzahl_Etiketten_cart_custom_count-${variantId}`);
    const errorText = document.getElementById(`cartQtyErrorText-${variantId}`);
    const updateBtn = document.getElementById(`cartItemUpdate-${variantId}`);

    const prodTags = document.getElementById(`productTags-${variantId}`).value.split('||');

    // Minimums per label type
    const MIN_BY_LABEL = {
        [customProperties.rollLabel]: 500,
        [customProperties.a4Label]: 1
    };

    const minAllowed = MIN_BY_LABEL[labelType];

    // Parse user value
    const rawVal = (countInput && countInput.value) ? String(countInput.value).trim() : '';
    const parsed = parseInt(rawVal, 10);
    const isNumber = Number.isInteger(parsed);

    // If label type unknown, clear errors and enable update (no min enforcement)
    if (typeof minAllowed === 'undefined') {
        if (errorText) errorText.textContent = '';
        if (updateBtn) updateBtn.disabled = false;
    } else {
        // Determine final value (use parsed if valid and >= min, otherwise minAllowed)
        const finalValue = (isNumber && parsed >= minAllowed) ? parsed : minAllowed;
        if (countInput) countInput.value = String(finalValue);

        // Clear any error and enable update button
        if (errorText) errorText.textContent = '';
        if (updateBtn) updateBtn.disabled = false;
    }

    // Toggle visibility classes for winding/lead selectors
    const leadDirectionEl = document.getElementById(`itemLeadDirection-${variantId}`);
    const windingDirectionEl = document.getElementById(`itemWindingDirection-${variantId}`);

    if (labelType === customProperties.rollLabel && !hasHideWindingForCartItem(prodTags)) {
        // Show both selectors
        if (leadDirectionEl) {
            leadDirectionEl.classList.remove('hide-winding-lead');
            leadDirectionEl.disabled = false; // enable
        }
        if (windingDirectionEl) {
            windingDirectionEl.classList.remove('hide-winding');
            windingDirectionEl.disabled = false; // enable
        }
    } else {
        // Hide both selectors
        if (leadDirectionEl) {
            leadDirectionEl.classList.add('hide-winding-lead');
            leadDirectionEl.disabled = true; // disable
        }
        if (windingDirectionEl) {
            windingDirectionEl.classList.add('hide-winding');
            windingDirectionEl.disabled = true; // disable
        }
    }

    // Special case: if winding value means "none", hide & disable lead
    if (windingDirectionEl) {
        const leadVal = windingDirectionEl.value || '';
        if (leadVal === customProperties.windingNoneNeeded && leadDirectionEl) {
            leadDirectionEl.classList.add('hide-winding-lead');
            leadDirectionEl.disabled = true;
        }
    }

}


/**
 * Function to validate custom input Qty from cart.
 * @param inputId
 * @returns
 */
function validateCustomInput(inputId) {

    var newQtyInput = $(inputId).val().trim();
    var prevQtyInput = parseInt($(inputId).attr("data-prevVal").trim());
    $(inputId).val(parseInt(newQtyInput));
    var executionLabelType = $(inputId).attr("data-labelType").trim();
    var dataVariantId = $(inputId).attr("data-variantId").trim();
    var cartErrorEle = $('#cartQtyErrorText-' + dataVariantId);
    cartErrorEle.text('').show();
    var errorMessage = '';

    cartItemRefresh = $('#cartItemUpdate-' + dataVariantId);
    var newitemLabel = $('#itemLabel-' + dataVariantId).val();



    if (newQtyInput % 1 != 0) {

        cartSubmit.attr("disabled", "disabled");
        cartItemRefresh.attr("disabled", "disabled");
        $(inputId).addClass('invalid');
        $(inputId).val(prevQtyInput);
        cartErrorEle.text('Enter a number between 1 and 100,000').fadeOut(4000);

        activateCartSubmit();
        return "valid";

    } else if (newQtyInput <= 0) {

        if (newitemLabel == customProperties['rollLabel']) {
            errorMessage = 'Enter minimum quantity - 500';

        } else {
            errorMessage = 'Enter minimum quantity - 1';
        }

        showCartError(inputId, errorMessage, cartErrorEle);
        $('.cartItemRefresh').attr("disabled", "disabled");
        cartSubmit.attr("disabled", "disabled");
        cartItemRefresh.attr("disabled", "disabled");
        return "invalid";


    } else if (newitemLabel == customProperties['rollLabel'] && newQtyInput < 500) {

        errorMessage = "Enter minimum quantity - 500";
        showCartError(inputId, errorMessage, cartErrorEle);
        cartSubmit.attr("disabled", "disabled");
        cartItemRefresh.attr("disabled", "disabled");
        return "invalid";

    } else if (newQtyInput > 100000) {

        errorMessage = "The maximum order quantity is currently 100,000 pieces.";
        showCartError(inputId, errorMessage, cartErrorEle);
        $(inputId).val('100000');
        cartSubmit.attr("disabled", "disabled");
        cartItemRefresh.attr("disabled", "disabled");
        return "invalid";

    } else {

        activateCartSubmit();
        cartErrorEle.text("");
        cartItemRefresh.removeAttr("disabled");
        return "valid";

    }
}

/**
 * Function to show error from cart.
 * @param inputId
 * @param message
 * @param errorEle
 */
function showCartError(inputId, message, errorEle) {
    cartSubmit.attr("disabled", "disabled");
    $(inputId).addClass('invalid');
    errorEle.text(message);
}

/**
 * For acivating the cart submit button and removing the vailidation error
 */
function activateCartSubmit() {
    cartSubmit.removeAttr("disabled");
    cartCustomInputEle.removeClass('invalid');
}

function checkLeadingEdge(selectEl) {
    const variantId = selectEl.getAttribute("data-variantId");
    const selectedValue = selectEl.value;
    const leadDirectionEl = document.getElementById(`itemLeadDirection-${variantId}`);
    if (!leadDirectionEl) return; // If section not found, do nothing

    if (selectedValue === customProperties.windingNoneNeeded) {
        leadDirectionEl.classList.add('hide-winding-lead');
        leadDirectionEl.disabled = true; // disable
    } else {
        leadDirectionEl.classList.remove('hide-winding-lead');
        leadDirectionEl.disabled = false; // enable
    }
}

function checkExcludedGlue(elem) {
    const variantId = elem.getAttribute("data-variantId")?.trim();
    if (!variantId) return;

    const preselectedValue = (document.getElementById(`existingMaterial-${variantId}`)?.value || '').trim();
    const currentValue = (elem.value || '').trim();

    const adhesiveSelect = document.getElementById(`itemAdhesive-${variantId}`);
    if (!adhesiveSelect) return;

    // --- Helpers ---
    const addOption = (id, name) => {
        if (!document.getElementById(id)) {
            const option = document.createElement("option");
            option.id = id;
            option.setAttribute("data-itemname", name);
            option.value = name;
            option.setAttribute("data-proprtyname", "kleber");
            option.textContent = name;
            adhesiveSelect.appendChild(option);
        }
    };

    const removeOption = (id, fallback = true) => {
        const option = document.getElementById(id);
        if (option) {
            // If removed option was selected → choose fallback
            if (option.selected && fallback && adhesiveSelect.options.length > 1) {
                // Pick the first available option
                adhesiveSelect.value = adhesiveSelect.options[0].value;
            }
            option.remove();
        }
    };

    // on changing the option, the tags will check
    let prodTags = document.getElementById(`productTags-${variantId}`).value.split('||');
    let isPeelableExcluded = true;
    let isWashableExcluded = true;

    // let isPeelableExcluded =
    //     (prodTags.includes("excludeNaturpapierPeelable") && currentValue === customProperties.texturedPaper) ||
    //     (prodTags.includes("excludeNaturpapierLeichtlöslich") && currentValue === customProperties.texturedPaper) || //old tag
    //     (prodTags.includes("excludePapierPeelable") && currentValue === customProperties.standardPaper) ||
    //     (prodTags.includes("excludePapierLeichtlöslich") && currentValue === customProperties.standardPaper) || // old tag
    //     (prodTags.includes("excludePPFilmPeelable") && currentValue === customProperties.ppFilm);

    let isPermanentExcluded =
        (prodTags.includes("excludeNaturpapierPermanent") && currentValue === customProperties.texturedPaper) ||
        (prodTags.includes("excludePapierPermanent") && currentValue === customProperties.standardPaper) ||
        (prodTags.includes("excludePPFilmPermanent") && currentValue === customProperties.ppFilm);

    // let isWashableExcluded =
    //     (prodTags.includes("excludeNaturpapierWatersoluble") && currentValue === customProperties.texturedPaper) ||
    //     (prodTags.includes("excludeNaturpapierWasserloeslich") && currentValue === customProperties.texturedPaper) || //old tag
    //     (prodTags.includes("excludePapierWatersoluble") && currentValue === customProperties.standardPaper) ||
    //     (prodTags.includes("excludePapierWasserloeslich") && currentValue === customProperties.standardPaper) || // old tag
    //     (prodTags.includes("excludePPFilmWatersoluble") && currentValue === customProperties.ppFilm) ||
    //     (currentValue === customProperties.ppFilm)

    let adhesivesExcluded = [
        { excluded: isPeelableExcluded, id: 'peelableAdhesiveElement', value: customProperties.peelableAdhesive },
        { excluded: isPermanentExcluded, id: 'permanentAdhesiveElement', value: customProperties.permanentAdhesive },
        { excluded: isWashableExcluded, id: 'washableAdhesiveElement', value: customProperties.washableAdhesive },
    ];

    adhesivesExcluded.forEach(({ excluded, id, value }) => {
        if (excluded) {
            removeOption(`${id}-${variantId}`);
        } else {
            addOption(`${id}-${variantId}`, value);
        }
    });

}


/**
 * Function for updating the quatity with new custom qty
 * @param obj
 */
function updateProduct(buttonElement) {
    const getAttr = (attr) => buttonElement.getAttribute(attr)?.trim() || '';
    const variantId = getAttr("data-variantId");
    const productId = getAttr("data-productId");
    const productSKU = getAttr("data-productSku");
    const existingQty = getAttr("data-existingQty");
    const lineItemNumber = getAttr("data-lineItem");
    const rawProperties = getAttr("data-itemProperties");
    const labelWidthForCalc = getAttr("data-item-width-calc");
    const labelHeightForCalc = getAttr("data-item-height-calc");
    const labelWidthOriginal = getAttr("data-item-width-original");
    const labelHeightOriginal = getAttr("data-item-height-original");
    const productName = getAttr("data-product-name");
    const isTamperSeal = productName.includes('Tamper Seal');

     // Helper to safely get element value by id
    const getValueById = (id) => document.getElementById(id)?.value?.trim() || '';
    // Helper to get selected option value by selector
    const getSelectedValue = (selector) => document.querySelector(selector)?.value || '';
    const newCustomQty = getValueById(`item_cart_custom_count-${variantId}`);

    var productType = buttonElement?.getAttribute("data-product-type")?.trim();
    if (productType == 'Mustermappe') {
        openHoneyLoader();
        var lineIndex = buttonElement?.getAttribute("data-itemIndex")?.trim();
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                line: lineIndex,
                quantity: newCustomQty,
            },
        }).then((data) => {
            //only remove item and update cart
            window.location.href = '/cart';
        });
        return true;
    }

    if (!variantId || !rawProperties) return;

    const existingLabel = getValueById(`existingLabelType-${variantId}`);
    const existingMaterial = getValueById(`existingMaterial-${variantId}`);
    const existingKleber = getValueById(`existingKleber-${variantId}`);
    const existingWindingDirection = getValueById(`existingWindingDirection-${variantId}`);
    const existingLeadingDirection = getValueById(`existingLeadingDirection-${variantId}`);

    const validationStatus = validateCustomInput(`#item_cart_custom_count-${variantId}`);
    const newLabel = getSelectedValue(`#itemLabel-${variantId} option:checked`);
    const newMaterial = getSelectedValue(`#itemMaterial-${variantId} option:checked`);
    const newKleber = getSelectedValue(`#itemAdhesive-${variantId} option:checked`);
    let newWindingDirection = getSelectedValue(`#itemWindingDirection-${variantId} option:checked`);

    if (isTamperSeal) {
        newWindingDirection = customProperties.windingNotPossible;
    }
    const newLeadingDirection = (isTamperSeal || newWindingDirection == customProperties.windingNoneNeeded)
    ? "" : getSelectedValue(`#itemLeadDirection-${variantId} option:checked`);

    if (newCustomQty < 500 && newLabel === customProperties['rollLabel']) {
      const errorEl = document.getElementById(`cartQtyErrorText-${variantId}`);
      if (errorEl) {
        errorEl.textContent = 'Enter the minimum quantity: 500';
        setTimeout(() => errorEl.textContent = '', 4000);
      }
      return true;
    }

    let existingProperties;
    try {
      existingProperties = JSON.parse(rawProperties);
    } catch {
      console.error("Invalid itemProperties JSON");
      return;
    }

    // Initialize newProperties with default keys and empty values
    const newProperties = {
      SKU: productSKU || '',
      [customProperties.labelWidth]: '',
      [customProperties.labelHeight]: '',
      [customProperties.numberOflabels]: '',
      [customProperties.labelType]: '',
      [customProperties.material]: '',
      [customProperties.adhesive]: '',
      [customProperties.windingDirection]: '',
      [customProperties.windingLeftRight]: '',
      "customization reference": ''
    };

    // Decode function assumed to exist, maps existingProperties to newProperties

    // helper map for override/default values
    const DEFAULTS = {
        [customProperties.numberOflabels]: newCustomQty,
        [customProperties.labelType]: newLabel,
        [customProperties.material]: newMaterial,
        [customProperties.adhesive]: newKleber,
        [customProperties.windingDirection]: newWindingDirection,
        [customProperties.windingLeftRight]: newLeadingDirection
    };

    existingProperties.forEach(([rawKey, rawValue]) => {
        const key = decode(rawKey);
        const value = decode(rawValue);

        // compute what should be stored
        let finalValue = value; // default: keep existing value

        if (key === customProperties.numberOflabels) {
            // always prefer newCustomQty (if provided), otherwise fall back to existing value
            finalValue = (typeof newCustomQty !== 'undefined' && newCustomQty !== null) ? newCustomQty : value;
        } else if (key === customProperties.labelType) {
            finalValue = (typeof newLabel !== 'undefined' && value !== newLabel) ? newLabel : value;
        } else if (key === customProperties.material) {
            finalValue = (typeof newMaterial !== 'undefined' && value !== newMaterial) ? newMaterial : value;
        } else if (key === customProperties.adhesive) {
            finalValue = (typeof newKleber !== 'undefined' && value !== newKleber) ? newKleber : value;
        } else if (key === customProperties.windingDirection) {
            finalValue = (typeof newWindingDirection !== 'undefined' && value !== newWindingDirection) ? newWindingDirection : value;
        } else if (key === customProperties.windingLeftRight) {
            finalValue = (typeof newLeadingDirection !== 'undefined' && value !== newLeadingDirection) ? newLeadingDirection : value;
        }

        // write (or create) the property
        newProperties[key] = finalValue;
    });


    // Make sure any expected keys that weren't present get created with defaults
    Object.keys(DEFAULTS).forEach((k) => {
        if (!newProperties.hasOwnProperty(k) || newProperties[k] === '' || typeof newProperties[k] === 'undefined' || newProperties[k] === null) {
            newProperties[k] = DEFAULTS[k];
        }
    });
    if(newProperties[customProperties.windingDirection] == customProperties.windingNoneNeeded){
        newProperties[customProperties.windingLeftRight] = "";
    }


    // Fix SKU fallback
    if (!newProperties.SKU) {
        newProperties.SKU = productSKU;
    }

    // Handle winding properties logic
    if (newProperties[customProperties.labelType] === customProperties.rollLabel) {
        // in case if roll paper selected and widning not selected by deafult
        if (!newProperties[customProperties.windingDirection]) {
            newProperties[customProperties.windingDirection] = customProperties.windingNoneNeeded;
            newProperties[customProperties.windingLeftRight] = "";
        }
        // in case if winding direction none needed and leading edge has value
        if(newProperties[customProperties.windingDirection] == customProperties.windingNoneNeeded){
            delete newProperties[customProperties.windingLeftRight];
        }
    } else if (newProperties[customProperties.labelType] === customProperties.a4Label) {
        delete newProperties[customProperties.windingDirection];
        delete newProperties[customProperties.windingLeftRight];
    }

    // Honey tamper-evident seal
    if (isTamperSeal && newProperties[customProperties.labelType] === customProperties.rollLabel) {
        newProperties[customProperties.windingDirection] = customProperties.windingNotPossible;
        delete newProperties[customProperties.windingLeftRight];
    }

    if(labelWidthForCalc > 0){
        newProperties[customProperties.labelWidth] = (labelWidthOriginal * 0.0393700787).toFixed(2) + ' Inch';
        newProperties[customProperties.labelHeight] = (labelHeightOriginal * 0.0393700787).toFixed(2) + ' Inch';
    }

    // Check if update is necessary
    const isQtyChanged = existingQty !== newCustomQty;
    const isLabelChanged = existingLabel !== newLabel;
    const isMaterialChanged = existingMaterial !== newMaterial;
    const isKleberChanged = existingKleber !== newKleber;
    const isWindingDirectionChanged = existingWindingDirection !== newWindingDirection;
    const isLeadingDirectionChanged = existingLeadingDirection !== newLeadingDirection;

    if (validationStatus === 'valid' &&
        (
            isQtyChanged || isLabelChanged ||
            isMaterialChanged || isKleberChanged ||
            isWindingDirectionChanged || isLeadingDirectionChanged
        )
    ) {
        buttonElement.disabled = true;

        const getValue = (key) => newProperties[key] || '';

        const postData = {
            quantity: getValue(customProperties.numberOflabels),
            executiontype: getValue(customProperties.labelType),
            materialType: getValue(customProperties.material),
            glueType: getValue(customProperties.adhesive),
            // width: parseInt(getValueById(`labelWidth-${variantId}`), 10) || 0,
            // height: parseInt(getValueById(`labelHeight-${variantId}`), 10) || 0,
            width: (labelWidthForCalc > 0) ? labelWidthForCalc : labelWidthOriginal,
            height: (labelHeightForCalc > 0) ? labelHeightForCalc : labelHeightOriginal,
            calculatedPrice: getValue('Ausführung'),
            productId,
            productSKU: newProperties.SKU,
            windingDirection: getValue(customProperties.windingDirection),
            voraus: getValue(customProperties.windingLeftRight),
            shop: storeGlobal
        };

        const spinner = document.getElementById("overlaySpinner");
        if (spinner) {
            spinner.style.display = 'block';
            spinner.style.opacity = 1;
        }

        removeItem(variantId, postData, newProperties, lineItemNumber);
    }
}


/**
 * Remove existing item while updating the item from the cart.
 * @param variantId
 * @param postData
 * @param newProperties
 */
function removeItem(variantId, postData, newProperties, existingLineItemNumber) {
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            // id: parseFloat(variantId),
            line: parseFloat(existingLineItemNumber),
            quantity: 0,
        },
    }).then((data) => {
        createCustomBackendProduct(postData, newProperties);
    });
}

// Function to remove item from the cart and and backend
function removeCartItem(lineItem) {

    if (confirm('Are you sure you want to remove this item?')) {

        var lineIndex = lineItem?.getAttribute("data-itemIndex")?.trim();
        var productType = lineItem?.getAttribute("data-product-type")?.trim();

        try {
            properties = JSON.parse(
                lineItem.getAttribute('data-itemproperties') || '{}'
            );
        } catch (e) {
            console.warn('Unable to parse cart item properties.', e);
        }

        var hasProperties =  properties && Object.keys(properties).length > 0;

        if (lineItem != undefined && lineItem >= 0) {
            if (productType == 'Mustermappe') {
                openHoneyLoader();
            }
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: {
                    line: lineIndex,
                    quantity: 0,
                },
            }).then((data) => {
                if (productType == 'Mustermappe' || !hasProperties ) {
                    //only remove item and update cart
                    window.location.href = '/cart';
                } else {
                    processRemoveDesign(lineItem, 'cartDelete');
                }
            });
        }

    }

}

/**
 * Function to get new product variant ID
 * @param postData
 * @param NewlinePros
 */
function createCustomBackendProduct(postData, NewlinePros, method = '') {

    fetch(backendGraphURL + '/shopify/custom-product', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(postData)
    })
    .then(response => response.json())
    .then(data => {
        console.log(data, 'done..... success');
        if (data.status === 200 && data.body.variantId !== '') {
            let varientReturnId = data.body.variantId;
            if(method == 'reorder'){
                // for new version reorder setup
                customReorderProductToCart['variantId'] = varientReturnId;
                closeHoneyLoader();
                openPrintlaneReorderEditor();
            }else{
                // if update from the cart
                labelDesignProps = {
                    productId: postData.productId,
                    store: storeGlobal,
                    variantId: varientReturnId,
                    customerId: customerGlobalId,
                    selectedProperties: NewlinePros,
                    customerEmail: customerGlobalEmail,
                    customerName: customerGlobalFirstName,
                    token: NewlinePros['customization reference'],
                    event: 'update'
                };

                postSavedDesign(labelDesignProps,'update');
                addProdToCart(varientReturnId, 1, NewlinePros)
            }
        }
        if (data.status === 600) {
            closeHoneyLoader();
            console.log(data.message);
        }

    })
    .catch(error => {
        console.error(error, 'Failed to fetch variant details');
        console.error(response);
        closeHoneyLoader();

    })
    .finally(() => {

    });

    /*var baseURL = backendURL + '/shopify/createCustomP';

    $.ajax({
        url: baseURL,
        type: "POST",
        crossDomain: true,
        dataType: 'jsonp',
        data: { "data": JSON.stringify(postData) }
    }).done(function (response) {
        if (response.status == 200 && response.data.variantId !== '') {
            if(method == 'reorder'){
                // for new version reorder setup
                customReorderProductToCart['variantId'] = response.data.variantId;
                closeHoneyLoader();
                openPrintlaneReorderEditor();
            }else{
                // if update from the cart
                labelDesignProps = {
                    productId: postData.productId,
                    store: storeGlobal,
                    variantId: response.data.variantId,
                    customerId: customerGlobalId,
                    selectedProperties: NewlinePros,
                    customerEmail: customerGlobalEmail,
                    customerName: customerGlobalFirstName,
                    token: NewlinePros['customization reference'],
                    event: 'update'
                };

                postSavedDesign(labelDesignProps,'update');
                addProdToCart(response.data.variantId, 1, NewlinePros)
            }
        }
        if (response.status == 600) {
            alert(response.message)
        }

    }).fail(function (response) {
        console.error(response);
        document.querySelectorAll('.cartLoader').forEach(el => el.classList.add('hide'));
    });*/
}

function removeEmptyKeys(obj) {
    Object.keys(obj).forEach(key => {
        if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        }
    });
}

/**
 * ShopifyAjax function for adding items to the cart.
 * @param id
 * @param qty
 * @param props
 */
function addProdToCart(id, qty, props) {
    removeEmptyKeys(props);
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: qty,
            id: id,
            properties: props
        },
        dataType: 'json',
        success: function (response) {

            cartCacheCheck = setInterval(function () {
                $.ajax({
                    url: '/cart.js',
                    type: 'post',
                    dataType: 'json',
                    success: function (res) {

                        if (res.items != undefined) {
                            $.each(res.items, function (key, lineItem) {

                                if (lineItem.id == id && lineItem.price > 0) {
                                    clearInterval(cartCacheCheck);
                                    window.location.href = '/cart';
                                }
                            })
                        }

                    }
                });

            }, 1000);

        },
        error: function (err) {
            console.log(
                'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.'
            );
        }
    });
}




/**cart items modal related section START */

/* Function to manage cart image sliders */
var slideIndex = 1;

/**
 * Next/previous controls
 * @param n
 */
function plusSlides(n) {
    showSlides(slideIndex += n);
}

/**
 * Thumbnail image controls
 * @param n
 */
function currentSlide(n) {
    showSlides(slideIndex = n);
}

/**
 * Functions to show slides
 * @param n
 */
function showSlides(n) {
    var i;
    var slides = document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
    if (n > slides.length) { slideIndex = 1 }
    if (n < 1) { slideIndex = slides.length }
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex - 1].style.display = "block";
}

/**
 * For opening the cart image thumpnails in modal
 */
function openModal() {
    const modal = document.getElementById("myModal");
    const span = document.querySelector(".close");
    const modalContentArea = document.getElementById("modalContentArea");
    const slideDotCount = document.getElementById("slideDotCount");

    let imageContent = '';
    let dotContent = '';

    customizedImages.forEach((image, index) => {
        const count = index + 1;
        imageContent += `
            <div class="mySlides fade" style="display: block;">
                <p class="expanded-width slider-image" style="text-align: center;">${image}</p>
            </div>
        `;
        dotContent += `<span class="dot" style="margin: 0px 5px;" onclick="currentSlide(${count})"></span>`;
    });

    modalContentArea.innerHTML = imageContent;
    if (customizedImages.length > 1) {
        slideDotCount.innerHTML = dotContent;
    }

    modal.style.display = "block";
    showSlides(slideIndex);

    span.onclick = function () {
        modal.style.display = "none";
        document.querySelectorAll(".cart-submit").forEach(btn => btn.classList.remove("spin"));
    };

    window.onclick = function (event) {
        if (event.target === modal) {
            modal.style.display = "none";
            document.querySelectorAll(".cart-submit").forEach(btn => btn.classList.remove("spin"));
        }
    };
}




async function validateCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const errors = [];
    const mismatches = [];

     // Remove previous highlights before validating again
    document.querySelectorAll('.cart-item--missing-properties').forEach(item => {
        item.classList.remove('cart-item--missing-properties');
    });

    cart.items.forEach(item => {

        const validation = validateCartItem(item);

        if (!validation.valid) {
            errors.push({
                product: item.product_title,
                missing: validation.missing,
                key: item.key,
                variantId: item.variant_id
            });

            // Highlight the corresponding cart item
            const cartItem = document.querySelector(
                `[data-item-key="${CSS.escape(item.key)}"]`
            );

            if (cartItem) {
                cartItem.classList.add('cart-item--missing-properties');
            }
        } else if (validation.mismatch) {
            mismatches.push(item);
        }

    });

    return {
        valid: errors.length === 0,
        errors,
        mismatches,
        currency: cart.currency
    };
}

/**
 * Replace a cart item whose variant does not match its properties with a correctly priced variant.
 * Returns the old and new line price.
 * @param item
 */
async function repairCartItem(item) {
    const props = { ...item.properties };
    // Look up by variant id: the line item key changes whenever the properties are changed
    const updateBtn = document.getElementById(`cartItemUpdate-${item.variant_id}`);
    const getAttr = (attr) => updateBtn?.getAttribute(attr)?.trim() || '';

    // Size in mm from a property like "40mm" or "1.57 Inch"
    const toMM = (value) => {
        const number = parseFloat(String(value || '').replace(',', '.'));
        if (isNaN(number)) return '';
        return /inch/i.test(value) ? Math.round(number * 25.4) : Math.round(number);
    };

    // Same width/height handling as updateProduct()
    const widthForCalc = getAttr('data-item-width-calc');
    const heightForCalc = getAttr('data-item-height-calc');
    const widthOriginal = Number(getAttr('data-item-width-original')) || toMM(props[customProperties.labelWidth]);
    const heightOriginal = Number(getAttr('data-item-height-original')) || toMM(props[customProperties.labelHeight]);

    if (!widthOriginal || !heightOriginal) {
        throw new Error('Label size not found for ' + item.product_title);
    }

    const postData = {
        quantity: props[customProperties.numberOflabels] || '',
        executiontype: props[customProperties.labelType] || '',
        materialType: props[customProperties.material] || '',
        glueType: props[customProperties.adhesive] || '',
        width: (widthForCalc > 0) ? widthForCalc : widthOriginal,
        height: (heightForCalc > 0) ? heightForCalc : heightOriginal,
        calculatedPrice: '',
        productId: item.product_id,
        productSKU: props.SKU || item.sku || '',
        windingDirection: props[customProperties.windingDirection] || '',
        voraus: props[customProperties.windingLeftRight] || '',
        shop: storeGlobal
    };

    const response = await fetch(backendGraphURL + '/shopify/custom-product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData)
    }).then(r => r.json());

    const newVariantId = response?.body?.variantId;
    if (response.status !== 200 || !newVariantId) {
        throw new Error('Variant could not be created: ' + JSON.stringify(response));
    }

    // Add the corrected item first, so the cart never loses the item if something fails
    removeEmptyKeys(props);
    const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: newVariantId, quantity: 1, properties: props })
    });
    const added = await addResponse.json();
    if (!addResponse.ok) {
        throw new Error('Corrected item could not be added: ' + JSON.stringify(added));
    }

    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
    });

    // Keep the saved design linked to the new variant
    postSavedDesign({
        productId: item.product_id,
        store: storeGlobal,
        variantId: newVariantId,
        customerId: customerGlobalId,
        selectedProperties: props,
        customerEmail: customerGlobalEmail,
        customerName: customerGlobalFirstName,
        token: props['customization reference'],
        event: 'update'
    }, 'update');

    return {
        product: item.product_title,
        oldPrice: item.final_line_price,
        newPrice: added.final_line_price ?? added.items?.[0]?.final_line_price
    };
}


function validateCartItem(item) {

    // Skip Sample Book
    if (Number(item.product_id) === SAMPLE_BOOK_PRODUCT_ID) {
        return {
            valid: true,
            missing: []
        };
    }

    const props = item.properties || {};
    const missing = [];

    const requiredFields = [
        customProperties.numberOflabels,
        customProperties.material,
        customProperties.adhesive,
        customProperties.labelWidth,
        customProperties.labelHeight
    ];

    requiredFields.forEach(field => {

        if (!props[field]) {
            missing.push(field);
        }

    });

    // Design / customization reference
    if (!props['customization reference']) {
        missing.push(translations.design);
    }

    // The variant was created (and priced) by the backend for a specific configuration.
    // If the line item properties no longer match it, the item has to be repaired before checkout.
    const mismatch = missing.length === 0 &&
        (Number(item.quantity) !== 1 || !variantMatchesProperties(item, props));

    return {
        valid: missing.length === 0,
        missing,
        mismatch
    };
}

/**
 * Rebuild the variant title the backend creates for these properties
 * ("qty/type/material/adhesive[/winding[/leading edge]]/price") and compare it with the cart variant.
 * @param item
 * @param props
 */
function variantMatchesProperties(item, props) {
    const variantTitle = String(item.variant_options?.[0] ?? item.variant_title ?? '').trim();
    const labelType = props[customProperties.labelType] || '';

    let expected = [
        Number(props[customProperties.numberOflabels]),
        labelType,
        props[customProperties.material] || '',
        props[customProperties.adhesive] || ''
    ].join('/');

    if (labelType === customProperties.rollLabel) {
        const windingDirection = props[customProperties.windingDirection] || '';
        expected += '/' + windingDirection;

        if (windingDirection !== customProperties.windingNoneNeeded) {
            expected += '/' + (props[customProperties.windingLeftRight] || '');
        }
    }

    if (variantTitle === expected) return true;

    // Remaining part must be only the price appended by the backend
    const rest = variantTitle.startsWith(expected + '/') ? variantTitle.slice(expected.length + 1) : '';
    return rest !== '' && !isNaN(Number(rest));
}


async function getSpinner(ele) {

    // Final validation before checkout
    const validation = await validateCart();

    if (!validation.valid) {

        const content = validation.errors.map(error => `
            <div class="checkout-validation-item">
                <h4>${error.product}</h4>
            </div>
        `).join('');

        showModal({
            title: translations.checkoutValidationTitle,
            content: `
                ${content}
                <p style="margin-top:20px;">
                    ${translations.checkoutValidationFooter}
                </p>
                <p style="margin-top:20px;">
                    ${translations.checkoutValidationThankYou}
                </p>
            `,
            buttons: [
                {
                    text: translations.ok,
                    class: 'button button--regular  button--regular-mobile  button--solid'
                }
            ]
        });

        return;
    }

    // Items whose price does not match the selected options: repair and show the new price
    if (validation.mismatches.length > 0) {
        openHoneyLoader();

        const repaired = [];
        const failed = [];
        for (const item of validation.mismatches) {
            try {
                repaired.push(await repairCartItem(item));
            } catch (error) {
                console.error(error, 'Cart repair failed');
                failed.push(item.product_title);
            }
        }

        closeHoneyLoader();

        // Could not repair: ask the customer to add the product again
        if (failed.length > 0) {
            showModal({
                title: translations.checkoutValidationTitle,
                content: `
                    ${failed.map(product => `<div class="checkout-validation-item"><h4>${product}</h4></div>`).join('')}
                    <p style="margin-top:20px;">${translations.checkoutValidationFooter}</p>
                `,
                buttons: [
                    {
                        text: translations.ok,
                        class: 'button button--regular  button--regular-mobile  button--solid',
                        onClick: () => { window.location.href = '/cart'; }
                    }
                ]
            });
            return;
        }

        const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency',
            currency: validation.currency
        }).format((cents || 0) / 100);

        const content = repaired.map(item => `
            <div class="checkout-validation-item">
                <h4>${item.product}</h4>
                <p><del>${money(item.oldPrice)}</del> → <strong>${money(item.newPrice)}</strong></p>
            </div>
        `).join('');

        showModal({
            title: translations.checkoutPriceUpdatedTitle,
            content: `
                <p>${translations.checkoutPriceUpdatedMessage}</p>
                ${content}
            `,
            buttons: [
                {
                    text: translations.ok,
                    class: 'button button--regular  button--regular-mobile  button--solid',
                    onClick: () => { window.location.href = '/cart'; }
                }
            ]
        });

        return;
    }

    customizedImages = [];
    let productCartCount = 0;

    document.querySelectorAll('.cart-item__thumbnail .customImages').forEach(function (item) {

        const img = item.querySelector('img');
        const productType = item.getAttribute('data-productType')?.trim();

        productCartCount++;

        if (productType !== 'Mustermappe' && img) {
            customizedImages.push(img.outerHTML);
        }

    });

    if (customizedImages.length > 0) {
        openModal();
    } else if (productCartCount > 0) {
        submitCheckout();
    }
}

/**
 * Function to moving to the checkout after confirming the slider images in cart page
 *
 */
function submitCheckout() {
    document.getElementById('myModal').style.display = 'none';
    openHoneyLoader();
    document.getElementById('cartSubmit').click();
}

/**
 * For closing the modal.
 * @param ele
 */
function closeModal(ele) {
    document.getElementById('myModal').style.display = 'none';
}
/**cart items modal related section END */


/**Reorder Functions Start */
/**
 *
 * @param ele
 */
function ProcessReorder(ele) {
    var el = $(ele);
    el.addClass('loading');
    var lineItemDetails = el.attr('data-variant-ids').split('||');
    var cartCustomDesignes = [];

    // process all items in an order
    var cart = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {

            $.each(data['items'], function (key, item) {
                cartCustomDesignes.push(item['properties']['customization reference']);
            })
            processCart(el, lineItemDetails, cartCustomDesignes);
        });


}

async function loadThumbnail(key) {
    try {
        // Use await inside the async function
        const url = await printlane.loadThumbnail(key);
    } catch (error) {
        console.error('Error loading thumbnail:', error);
    }
}

/**
 *
 * @param lineProperties
 * @param variantId
 */
function createCartItems(lineProperties, variantId, totalItems = null) {


    if (totalItems != null) {
        reorderTotalItems = totalItems;
    }
    addItemsToCart(variantId, lineProperties);

}

function getWindingDirection(propsToCart) {
    if (propsToCart[customProperties['windingDirection']] != undefined && propsToCart[customProperties['windingDirection']] != '') {
        return propsToCart[customProperties['windingDirection']];
    }
    if ((propsToCart[customProperties['labelType']] == customProperties['rollLabel']) && (propsToCart[customProperties['windingDirection']] === undefined)) {
        return customProperties['windingNoneNeeded'];
    }
    return '';
}

/**
 *
 * @param el
 * @param lineItemDetails
 */
function processCart(el, lineItemDetails, cartCustomDesignes) {

    reorderTotalItems = lineItemDetails.filter(Boolean).length;

    var AllItems = [];

    $.each(lineItemDetails, function (key, lineItemData) {

        if (lineItemData.length > 0) {

            item = lineItemData.replace(/\n\s+/g, '').trim().split('|');

            var variantId = '';
            variantId = (item[0] != undefined && item[0].length > 0) ? item[0] : '';
            variantId = variantId.trim();
            // to skip the mustermap
            if (variantId.length > 0 && variantId != '41258938695871') {

                var lineProperties = (item[1] != undefined && item[1].length > 0) ? JSON.parse(item[1]) : '';
                var productId = (item[2] != undefined && item[2].length > 0) ? item[2] : '';
                var variantTitle = (item[3] != undefined && item[3].length > 0) ? item[3] : '';
                var variantSku = (item[4] != undefined && item[4].length > 0) ? item[4] : '';
                var variantWidth = (item[5] != undefined && item[5].length > 0) ? item[5] : '';
                var variantHeight = (item[6] != undefined && item[6].length > 0) ? item[6] : '';

                var newProperties = {};

                if (lineProperties['colorlab'] != undefined && lineProperties['colorlab'].length > 0 ||
                    lineProperties['customization reference'] != undefined && lineProperties['customization reference'].length > 0) {

                    $.each(lineProperties, function (key, value) {

                        if (key == "colorlab") {
                            newProperties['customization reference'] = value;

                        } else {
                            newProperties[key] = value;
                        }

                    })

                    if (variantTitle.length > 0 && newProperties[customProperties['labelType']] != ''
                        && newProperties[customProperties['material']] != '' && newProperties[customProperties['numberOflabels']] != '') {
                        variantTitle = variantTitle.split("/");
                        $.each(variantTitle, function (vkey, v_value) {
                            v_value = v_value.trim();
                            if (v_value == customProperties['a4Label'] || v_value == customProperties['rollLabel']) {
                                newProperties[customProperties['labelType']] = v_value;
                            } else if (v_value == customProperties['standardPaper'] || v_value == customProperties['texturedPaper'] || v_value == customProperties['ppFilm']) {
                                newProperties[customProperties['material']] = v_value;
                            } else {
                                newProperties[customProperties['numberOflabels']] = variantTitle[0].trim();
                            }

                        })
                    }

                }

                if (newProperties) {

                    var postData = {
                        "quantity": (newProperties[customProperties['numberOflabels']] != undefined) ? newProperties[customProperties['numberOflabels']] : '',
                        "executiontype": (newProperties[customProperties['labelType']] != undefined) ? newProperties[customProperties['labelType']] : '',
                        "materialType": (newProperties[customProperties['material']] != undefined) ? newProperties[customProperties['material']] : '',
                        "glueType": (newProperties[customProperties['adhesive']] != undefined) ? newProperties[customProperties['adhesive']] : '',
                        "width": variantWidth,
                        "height": variantHeight,
                        "calculatedPrice": (newProperties['Ausführung'] != undefined) ? newProperties['Ausführung'] : '',
                        "productId": productId,
                        // "productId": 7081003221183,
                        "productSKU": variantSku,
                        "windingDirection": (newProperties[customProperties['windingDirection']] != undefined) ? newProperties[customProperties['windingDirection']] : '',
                        "voraus": (newProperties[customProperties['windingLeftRight']] != undefined) ? newProperties[customProperties['windingLeftRight']] : '',
                        "shop" : storeGlobal
                    };

                    lineProperties[customProperties['numberOflabels']] = newProperties[customProperties['numberOflabels']];
                    lineProperties[customProperties['labelType']] = newProperties[customProperties['labelType']];
                    lineProperties[customProperties['material']] = newProperties[customProperties['material']];
                    lineProperties[customProperties['labelWidth']] = variantWidth + ' mm';
                    lineProperties[customProperties['labelHeight']] = variantHeight + ' mm';

                    if (lineProperties.colorlab != undefined) {
                        delete lineProperties['colorlab'];
                        lineProperties['customization reference'] = newProperties['customization reference'];
                    }

                    // var baseURL = backendURL + '/shopify/createCustomP';

                    // if same item in the cart no need to include it again
                    if (cartCustomDesignes.includes(lineProperties['customization reference'])) {

                        // reduce totals items for reload to cart page
                        reorderTotalItems = reorderTotalItems - 1;
                        // if no iem toinclude in the cart on reorder / move to the cart page
                        if (reorderTotalItems == 0) {
                            window.location.href = '/cart';
                        }
                    } else {

                        fetch(backendGraphURL + '/shopify/custom-product', {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(postData)
                        })
                        .then(response => response.json())
                        .then(data => {
                            console.log(data, 'done..... success');
                            if (data.status === 200 && data.body.variantId !== '') {
                                let varientReturnId = data.body.variantId;
                                createCartItems(lineProperties, varientReturnId)
                            }
                            if (data.status === 600) {
                                closeHoneyLoader();
                                console.log(data.message);
                            }

                        })
                        .catch(error => {
                            console.error(error, 'Failed to fetch variant details');
                            console.error(response);
                            closeHoneyLoader();

                        })
                        .finally(() => {

                        });
                        /*$.ajax({
                            url: baseURL,
                            type: "POST",
                            crossDomain: true,
                            dataType: 'jsonp',
                            data: { "data": JSON.stringify(postData) }
                        }).done(function (response) {
                            if (response.status == 200 && response.data.variantId !== '') {
                                createCartItems(lineProperties, response.data.variantId)
                            }

                        }).fail(function (response) {
                            console.error(response);
                            $('.cartLoader').addClass('hide');
                        });*/
                    }


                }
            } else {
                // if invalid item found reduce from total items
                reorderTotalItems = reorderTotalItems - 1;
            }

        }

    })

}

Shopify.moveAlong = function () {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        // pass the properties into addItem as well
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
    }
    // If the queue is empty, we will redirect to the cart page.
    else {
        reorderCacheCheck = setInterval(function () {
            var refreshCount = 0;
            $.ajax({
                url: '/cart.js?cache=false',
                type: 'post',
                dataType: 'json',
                success: function (res) {

                    var cartTotalElements = res.items.length;
                    if (res.items != undefined) {
                        $.each(res.items, function (key, lineItem) {
                            if (lineItem.price > 0) {
                                refreshCount += 1;
                            }
                        })
                    }
                    if (refreshCount == cartTotalElements) {
                        clearInterval(reorderCacheCheck);
                        window.location.href = '/cart';
                    }
                }
            });

        }, 1000);

    }
};

// Create a new Shopify.addItem function that takes the 'properties' parameter
Shopify.addItem = function (id, qty, properties, callback) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function () {
            if (typeof callback === 'function') {
                callback();
            }
        },
        error: function () { }
    });
}

/**
 *
 * @param variantID
 * @param quantity
 * @param properties
 */
function push_to_queue(variantID, quantity, properties) {
    Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
    });
}

/**
 *
 * @param varId
 * @param lineProperties
 */
function addItemsToCart(varId, lineProperties) {

    if (varId) {

        push_to_queue(varId, 1, lineProperties);
        reorderLineItemCount += 1;

        if (reorderLineItemCount == reorderTotalItems) {
            Shopify.moveAlong();
        }

    }
}

function getUrlParams(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }
/**Reorder Functions END */
